const STEPS = [
  {
    id: 1,
    label: '申込内容を入力'
  },
  {
    id: 2,
    label: '申込確認'
  },
  {
    id: 3,
    label: '申込完了'
  }
]

export { STEPS }
